import { render } from "./App.vue?vue&type=template&id=3f60dda4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\usuario\\Desktop\\themeforest-w6kxLMV7-vdemy-vuejs-education-online-courses-template\\vdemy-vuejs-education-online-courses-template\\vdemy-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__